import { render, staticRenderFns } from "./CurrentFirmware.vue?vue&type=template&id=2423f6ff&scoped=true"
import script from "./CurrentFirmware.vue?vue&type=script&lang=js"
export * from "./CurrentFirmware.vue?vue&type=script&lang=js"
import style0 from "./CurrentFirmware.vue?vue&type=style&index=0&id=2423f6ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2423f6ff",
  null
  
)

export default component.exports